const environmentType = process.env.NODE_ENV;
let url, authUrl;
if (process.env.REACT_APP_IS_ADP_PENTEST === "true") {
  url = "";
  authUrl = "https://staging.callexperts.com/auth";
} else if (
  process.env.REACT_APP_DEPLOYED_BETA === "true" &&
  environmentType === "production"
) {
  url = "https://api.callexperts.com/staginglogin";
  authUrl = "https://api.callexperts.com/auth";
} else if (environmentType === "production") {
  url = "https://go.callexperts.com/logingateway";
  authUrl = "https://staging.callexperts.com/auth";
} else {
  url = "http://localhost:3000/attendancetrackerstaging";
  authUrl = "http://localhost:48874/auth";
}

module.exports = { url, authUrl };
